import React, { useState } from 'react';

export default function Contact() {
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = () => {
    navigator.clipboard.writeText('info@domainaims.com');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section id="contact" className="py-12 md:py-16 lg:py-20 bg-gray-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-4 md:mb-6 leading-tight tracking-tight">
            READY TO ACQUIRE?
          </h2>
          <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed font-light">
            Take the first step towards owning the most powerful domain in combat sports. 
            Contact us today to discuss your acquisition.
          </p>
        </div>

        <div className="bg-deep-charcoal/90 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-gray-700">
          <div className="text-center space-y-6 md:space-y-8">
            <div className="space-y-3 md:space-y-4">
              <h3 className="text-xl md:text-2xl font-bold text-white">
                Send Your Interest to:
              </h3>
              
              <div className="flex flex-col lg:flex-row items-center justify-center gap-3 md:gap-4">
                <div className="bg-gray-800/80 rounded-lg p-3 md:p-4 flex items-center gap-2 md:gap-3 w-full lg:w-auto border border-gray-700">
                  <span className="text-xl md:text-2xl">📧</span>
                  <a 
                    href="mailto:info@domainaims.com" 
                    className="text-lg md:text-xl font-bold text-white hover:text-champagne-gold transition-colors duration-300 break-all"
                  >
                    info@domainaims.com
                  </a>
                </div>
                
                <button
                  onClick={handleCopyEmail}
                  className="bg-champagne-gold hover:bg-yellow-300 text-deep-charcoal font-semibold py-2 px-4 md:py-3 md:px-6 rounded-lg transition-all duration-300 cursor-pointer min-h-[44px] w-full lg:w-auto tracking-wide"
                >
                  {copied ? 'Copied!' : 'Copy Email'}
                </button>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 text-center">
              <div className="space-y-2">
                <div className="text-2xl md:text-3xl">⚡</div>
                <h4 className="text-base md:text-lg font-semibold text-white">Fast Response</h4>
                <p className="text-sm md:text-base text-gray-300 leading-relaxed font-light">We respond to all serious inquiries within 24 hours</p>
              </div>
              
              <div className="space-y-2">
                <div className="text-2xl md:text-3xl">💼</div>
                <h4 className="text-base md:text-lg font-semibold text-white">Professional Process</h4>
                <p className="text-sm md:text-base text-gray-300 leading-relaxed font-light">Secure transfer with industry-standard escrow</p>
              </div>
              
              <div className="space-y-2">
                <div className="text-2xl md:text-3xl">🤝</div>
                <h4 className="text-base md:text-lg font-semibold text-white">Flexible Terms</h4>
                <p className="text-sm md:text-base text-gray-300 leading-relaxed font-light">Multiple payment options and negotiable terms</p>
              </div>
            </div>

            <div className="bg-gradient-to-r from-champagne-gold/10 to-gray-800/20 rounded-xl p-4 md:p-6 border border-champagne-gold/20">
              <h4 className="text-lg md:text-xl font-bold text-white mb-2 md:mb-3">
                What to Include in Your Inquiry:
              </h4>
              <ul className="text-sm md:text-base text-gray-300 space-y-1 md:space-y-2 max-w-2xl mx-auto text-left font-light">
                <li>• Your organization and industry background</li>
                <li>• Intended use for WorldTitleFight.com</li>
                <li>• Timeline for acquisition</li>
                <li>• Budget range or initial offer</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}